"use client";

import { useState, useContext } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { LanguageContext } from "App";
import PatientSelector from "../../../CinicComponents/PatientSelector";
import SearchPackagesReq from "../../../Classes/Models/Requests/AccountingSessions/CreatePackageReq";
import ThreeStateCheckbox from "components/ThreeStateCheckbox";
import MDPhoneInput from "../../../components/MDInput/MDPhoneInput";

const SearchPackages = ({ setSearchReq }) => {
  const [Name, setName] = useState("");
  const [Patient, setPatient] = useState({});
  const [Id, setId] = useState();
  const [PatientNumber, setPatientNumber] = useState();
  const [IsPostPaid, SetIsPostPaid] = useState(undefined);
  const [StartDateFrom, setStartDateFrom] = useState("");
  const [StartDateTo, setStartDateTo] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const { translations } = useContext(LanguageContext);

  const onSearchClick = () => {
    const searchReq = new SearchPackagesReq();
    searchReq.packageName = Name;
    searchReq.patientId = Patient.getPatient?.id;
    searchReq.isPostPaid = IsPostPaid;
    searchReq.id = Id;
    searchReq.startdatefrom = StartDateFrom;
    searchReq.startdateto = StartDateTo;
    searchReq.phoneNumber = phoneNumber;

    searchReq.patientNumber = PatientNumber;
    console.log(searchReq);
    setSearchReq(searchReq);
  };

  return (
    <Card
      mb={3}
      id="SearchPackagesCard"
      className="mb-5"
      sx={{ padding: "1em" }}
    >
      <MDBox
        pt={2}
        px={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MDTypography variant="h6" fontWeight="medium">
          {translations.createAccountsessionPackageSearchSearchPackages}
        </MDTypography>
      </MDBox>

      <div className="row mt-4 px-2">
        <div className="col-md-4">
          <MDInput
            id={translations.createAccountsessionPackageSearchId}
            label={translations.createAccountsessionPackageSearchId}
            onChange={(e) => setId(e.target.value)}
            className="full-width"
          />
        </div>
        <div className="col-md-4">
          <MDInput
            id={translations.createAccountsessionPackageSearchPackageName}
            label={translations.createAccountsessionPackageSearchPackageNotes}
            onChange={(e) => setName(e.target.value)}
            className="full-width"
          />
        </div>
        <div className="col-md-4">
          <PatientSelector setPatient={setPatient} />
        </div>
      </div>

      <div className="row mt-4 px-2">
        <div className="col-md-4">
          <MDInput
            type="date"
            label="Start Date From"
            value={StartDateFrom}
            onChange={(e) => setStartDateFrom(e.target.value)}
            className="full-width"
            sx={{
              "& .MuiInputBase-input": {
                height: "50px",
                padding: "0 10px",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
        <div className="col-md-4">
          <MDInput
            type="date"
            label="Start Date To"
            value={StartDateTo}
            onChange={(e) => setStartDateTo(e.target.value)}
            className="full-width"
            sx={{
              "& .MuiInputBase-input": {
                height: "50px",
                padding: "0 10px",
              },
            }}
            InputLabelProps={{ shrink: true }}
          />
        </div>
        <div className="col-md-4">
          <ThreeStateCheckbox
            value={IsPostPaid}
            label={"Is Post Paid"}
            onChange={(value) => SetIsPostPaid(value)}
          />
        </div>
      </div>
      <div className="row mt-4 px-2">
        <div className="col-md-4">
          <MDPhoneInput
            value={phoneNumber}
            onChange={(value) => setPhoneNumber(value)}
          />
        </div>
      </div>
      <div className="col-12 mt-2">
        <MDTypography
          variant="caption"
          color="text"
          fontWeight="regular"
          style={{ display: "flex", alignItems: "center", gap: "5px" }}
        >
          <Icon fontSize="small" color="warning">
            info
          </Icon>
          Note: Packages created before (December 2025) will not appear when
          searching by the start date.
        </MDTypography>
      </div>
      <MDBox
        pt={2}
        px={2}
        display="flex"
        justifyContent="end"
        alignItems="right"
      >
        <MDButton
          onClick={() => onSearchClick()}
          sx={{
            backgroundColor: "#3560AD",
            "&:hover": { backgroundColor: "#4682B4" },
          }}
          color="info"
        >
          <Icon sx={{ fontWeight: "bold" }}>search</Icon>
          &nbsp;{translations.createAccountsessionSingleSessionSearchSearch}
        </MDButton>
      </MDBox>
    </Card>
  );
};

export default SearchPackages;
